import { Level } from './level'
import { Translator } from './translator'

export class EnglishLesson{
    id:string
    nameEn:string
    nameKh:string
    levels:Level[] = []
}